angular.module('ihestiaCommonDirectives.uploaderV2', []);
